module.exports = __webpack_public_path__ + "static/media/video03.d59de561.jpg";